import api from '../api'

export default {

  messages: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-messaging?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  get: async (id) => {
    return api.get('api/partner-messaging/'+id)
  },

  create: async message => {
    return api.post('api/partner-messaging',message)
  },

  jobs: async () => {
    return api.get('api/partner-messaging/jobs')
  },


}
